exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#maintenance {\r\n    border-radius: 10px;\r\n}\r\n\r\n#maintenance-form-wrapper {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1 0 auto;\r\n            flex: 1 0 auto;\r\n}\r\n\r\n#maintenance-form {\r\n    max-width: 384px;\r\n    padding: 48px;\r\n    background: #FFFFFF;\r\n    text-align: center;\r\n}\r\n\r\n.watermark-logo {\r\n    width: 128px;\r\n    margin: 32px auto;\r\n}\r\n\r\n.title {\r\n    font-size: 17px;\r\n    margin-top: 16px;\r\n}\r\n\r\n.subtitle {\r\n    margin: 16px 0;\r\n    max-width: 300px;\r\n    color: rgba(0, 0, 0, 0.54);\r\n    font-size: 15px;\r\n}\r\n\r\n.help-block {\r\n    text-align: left;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/phone-take-request/phone-take-request.component.css
// module id = ../../../../../src/app/directive/phone-take-request/phone-take-request.component.css
// module chunks = main